import React from 'react';
import { Route, Switch, Redirect, useRouteMatch } from 'react-router-dom';
import PointLayout from '../Layouts/PointLayout/PointLayout';

import Terminals from './Terminals/Terminals';
import Tickets from './Tickets/Tickets';
import Sportsbook from './Sportsbook/Sportsbook';
import Reports from './Reports/Reports';
import Balance from './Balance/Balance';
import Credit from './Credit/Credit';
import Consumptions from './Consumptions/Consumptions';

const Point = () => {
    const match = useRouteMatch();
    return (
        <PointLayout>
            <Switch>
                <Redirect exact from={`${match.url}/`} to={`${match.path}/tickets`} />
                <Route path={`${match.url}/terminals`} component={Terminals} />
                <Route path={`${match.url}/tickets`} component={Tickets} />
                <Route path={`${match.url}/sportsbook`} component={Sportsbook} />
                <Route path={`${match.url}/reports`} component={Reports} />
                <Route path={`${match.url}/balance`} component={Balance} />
                <Route path={`${match.url}/credit`} component={Credit} />
                <Route path={`${match.url}/consumptions`} component={Consumptions} />
            </Switch>
        </PointLayout>
    );
};

export default Point;
